import {Component, Input, OnInit} from '@angular/core';
import {WintersportWetterTexte} from '../../../../../../../../model/messwerte/rbb-wintersport-wetter';
import {take} from 'rxjs/operators';
import {FirebaseService} from '../../../../../../../../service/firebase/firebase.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-rbb-wintersport-wetter-texte',
  templateUrl: './rbb-wintersport-wetter-texte.component.html',
  styleUrls: ['./rbb-wintersport-wetter-texte.component.css','../wintersport-wetter.component.css']
})
export class RbbWintersportWetterTexteComponent implements OnInit {

  isLoading = false;

  HTML_REPLACE = /<[^>]*>/g;
  wintersportWetterTexte: WintersportWetterTexte;

  constructor(private firebaseService: FirebaseService, private matSnackBar: MatSnackBar) {
  }

  ngOnInit(): void {

    this.loadTexte();


  }

  public loadTexte() {
    this.firebaseService.getMesswerteMeteoGroupRBBFor('Wintersportwetter_Texte')
      .pipe(take(1))
      .subscribe({
        next: value => this.mapData(value.data()),
        error: err => this.matSnackBar.open('ERROR loadTexte() ' + err, 'Ok'),
        complete: () => this.isLoading = false
      });
  }


  private mapData(data) {

    this.wintersportWetterTexte = data;
    for (const region of this.wintersportWetterTexte.regionen) {
      region.prognose.text = region.prognose?.text.replace(this.HTML_REPLACE, '');
      region.prognose.ausspiel = region.prognose?.ausspiel.replace(new RegExp('h1', 'g'), 'h3');
      if (region.schneelage) {
        region.schneelage.text = region.schneelage?.text?.replace(this.HTML_REPLACE, '');
        region.schneelage.ausspiel = region.schneelage?.ausspiel?.replace(new RegExp('h1', 'g'), 'h3');
      }

    }

  }
}
